/** 서버 URL — 환경별 fallback. dashboard 패턴 그대로. */
export const SERVER_URL =
  import.meta.env.VITE_SERVER_URL ||
  'https://atgrd-agent-server.winter-brook-a4b4.workers.dev';

/**
 * localStorage 키 — 인증 세션 토큰 (Bearer).
 *
 * dashboard와 동일한 키 이름이지만 origin이 달라서 (console.pages.dev vs dashboard.pages.dev)
 * 별개 저장소. 즉 console에 로그인했다고 dashboard 자동 로그인 X. 별도 로그인 필요.
 */
export const STORAGE_KEY_SESSION_TOKEN = 'atgrd_session_token';
export const STORAGE_KEY_OWNER_ID = 'atgrd_owner_id';
